<onyx-section [heading]="`${I18N}.heading`">
  <onyx-toggle rightHeading [(checked)]="isEnabled"></onyx-toggle>

  @if (isEnabled()) {
    <div class="container">
      @if (chips().length > 1) {
        <onyx-chips
          label="labels.settings"
          [chips]="chips()"
          variant="secondary"
          [single]="true"
          [gap]="8"
          [(activeValues)]="selectedBranch"
        ></onyx-chips>
      }

      <div class="item">
        @if (selectedBranchForm() !== mainBranchForm()) {
          @let disabled = !selectedBranchForm() && mainBranchForm().invalid;
          <onyx-toggle
            label="labels.customSettings"
            [checked]="!!selectedBranchForm()"
            [disabled]="disabled"
            [onyxTooltip]="
              disabled ? 'labels.setDefaultSettingsFirst' : undefined
            "
            (checkedChange)="$event ? addBranchForm() : removeBranchForm()"
          ></onyx-toggle>
        }

        @if (selectedBranchForm(); as selectedBranchForm) {
          @for (branchForm of form().controls; track branchForm) {
            @if (branchForm === selectedBranchForm) {
              <app-contractor-shipping-type-form
                [form]="branchForm.controls.shippingType"
              ></app-contractor-shipping-type-form>
            }
          }
        }
      </div>
    </div>
  }
</onyx-section>
